export default __webpack_public_path__ + "static/5-1b21364b59bd00d106af1046b9c58412.png";